import React, { Component } from 'react';

import { withStyles } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import { withRouter } from 'react-router-dom';
import { pickBy, identity } from 'lodash';

import ReportFilter from "../../components/ReportComponents/ReportFilter";
import { REPORT_PARAMS } from "../../components/ReportComponents/ReportParams/reportParams";
import ReportTypes from "../../components/ReportComponents/ReportTypes";
import { getReport, requestReport } from "../../stores/api";
import styles, * as E from "./styles";
import { Button } from "@material-ui/core";
import { GetApp as DownloadIcon } from "@material-ui/icons";
import GenerateDialog from "../../components/ReportComponents/GenerateDialog";

/*
* For now hard code, but in the future we could change filters dynamically from backend configs
* */
const DEFAULT_REPORT_PARAMS = {
    'dateRange' : {'type':REPORT_PARAMS.REPORT_PARAM_DATE_RANGE},
    'regions' : {'type':REPORT_PARAMS.REPORT_PARAM_REGIONS},
    'client_profile_ids' : {'type':REPORT_PARAMS.REPORT_PARAM_CLIENT_PROFILE_IDS},
    'service_levels' : {'type':REPORT_PARAMS.REPORT_PARAM_SERVICE_LEVELS},
};

@inject("reportStore", "reportFormStore")
@observer
class ReportContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog : false
        }
    }

    componentDidMount() {
        this.props.reportStore.reset();
    }

    generateReport = () => {
        const { reportFormStore, reportStore } = this.props;
        reportStore.setError("");
        reportStore.setReportRequest({status:"PENDING"});
        const request = {
            type: reportStore.report.type,
            report_params: pickBy(reportFormStore.getData(), identity)
        };
        requestReport(request).then(res => {
            if (res.ok) {
                const {id, status, url, count} = res.data;
                reportStore.setReportRequest({...request, id, status, url, count});
                this.fetchReport(id);
            } else {
                reportStore.setReportRequest({...request, status: "ERROR", url: null, count: null});
                reportStore.setError(res.originalError? `${res.originalError.message} ${res.originalError.stack}` : "Error while requesting report");
                reportStore.setPolling(false);
                this.handleCloseDialog()
            }

        });
    }
    handleOpenDialog = () => {
        this.setState({showDialog: true}, this.generateReport)
    }

    handleCloseDialog = () => {
        this.setState({showDialog: false})
    }

    fetchReport = (id) => {
        const { reportStore } = this.props;
        const { reportRequest } = reportStore;
        reportStore.setPolling(true);
        getReport(id).then(res => {
            if (res.ok) {
                const {status, url, count} = res.data;
                reportStore.setReportRequest({...reportRequest, id, status, url, count});
                if (!["ERROR", "UPLOAD_ERROR", "COMPLETED", "NO_ITEMS"].includes(status)) {
                    setTimeout(() => {
                        this.fetchReport(id);
                    }, 5000);
                }

                if (["ERROR", "UPLOAD_ERROR", "COMPLETED", "NO_ITEMS"].includes(status)) {
                    reportStore.setPolling(false);
                }
            } else {
                reportStore.setError(res.data ? res.data.message : "Error while requesting report");
                reportStore.setPolling(false);
            }
        })
    }

    downloadUrl = (id, e) => {
        if (e) e.preventDefault();
        window.open(`${import.meta.env.REACT_APP_API_ROOT}/reports/uploaded/${id}/download`, '_blank', 'noopener');
    }

    /*
    * Check if report has been set and check if all report params are also set
    * */
    isReadyToGenerate = () =>{
        const { reportStore, reportFormStore } = this.props;
        const { report } = reportStore;
        const { data } = reportFormStore
        if( report && report.type != null ){
            //change to use report.inputParams when we are doing dynamic reports
            const inputParams = DEFAULT_REPORT_PARAMS;
            if(inputParams){
                let valid = true;
                Object.keys(inputParams).map((key, index) => {
                    //if param has not been set
                    if (!data.get(key) && !['service_levels'].includes(key)) {
                       if (valid) {
                            valid = false;
                        }
                    }
                });
                return valid;
            }else{
                return true;
            }
        }
        return false;
    }


  render() {

        const { reportStore, classes } = this.props
        const { reportRequest, existingReports,  error, polling } = reportStore;
        const { showDialog } = this.state;
        const readyToGenerate =  this.isReadyToGenerate() && !polling;


        return (
            <E.ReportContainer>
                <E.Header>
                    <E.HeaderLeft>
                        <ReportFilter reportParams={DEFAULT_REPORT_PARAMS} />
                    </E.HeaderLeft>
                </E.Header>
                <E.MainContainer>
                    <E.Row>
                        <ReportTypes />
                    </E.Row>
                    <E.Row>
                        <Button disabled={!readyToGenerate} onClick={readyToGenerate ? this.handleOpenDialog : undefined} variant="contained" color="primary" style={{ marginTop: 20, marginLeft: 20 }} startIcon={<DownloadIcon />}>
                            {`Download Report`}
                        </Button>
                    </E.Row>
                    <GenerateDialog
                        showDialog={showDialog}
                        handleCloseDialog={this.handleCloseDialog}
                        classes={classes}
                        polling={polling}
                        loading={polling}
                        existingReports={existingReports}
                        generateReport={this.generateReport}
                        reportRequest={reportRequest}
                        error={error}
                        downloadUrl={this.downloadUrl}
                    />

         </E.MainContainer>
      </E.ReportContainer>
    );
  }


}
export default withStyles(styles)(withRouter(ReportContainer));
